import { HgSupportedLanguage } from '@smg-real-estate/domus';
import isNil from 'lodash.isnil';

const SWISS_THOUSANDS_SEPARATOR = '\u2019';

const getThousandsSeparator = (locale: HgSupportedLanguage): string =>
  locale === HgSupportedLanguage.EN ? ',' : SWISS_THOUSANDS_SEPARATOR;

const formatIntegerWithSeparator = (num: number, separator: string): string => {
  const [intPart, fracPart] = String(num).split('.');
  const withSeparators = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, separator);
  return fracPart === undefined ? withSeparators : `${withSeparators}.${fracPart}`;
};

export const formatLocalizedNumber = (
  value: number | null | undefined,
  rounded: boolean,
  locale: HgSupportedLanguage,
): string => {
  if (isNil(value)) {
    return '';
  }

  const num = rounded ? Math.round(value / 100) * 100 : value;
  return formatIntegerWithSeparator(num, getThousandsSeparator(locale));
};
